import { ToggleSwitch } from "@/components";
import { RightWrapper } from "../../../components";
import { useState, useCallback, useMemo, useEffect } from "react";
import { useApi, useAlert } from "@/";
import { useSelector, useDispatch } from "react-redux";
import { addCourierSettings } from "../../../app/slices";
const CourierMgmt = () => {
  const { callApi } = useApi();
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();

  const serviceableCouriers = useSelector(
    (state) => state.app?.appData?.courier
  );

  // Sample serviceableCouriers data
  //   {
  //     "_id": "67c0344bf2947d061341a4c1",
  //     "name": "Shadowfax",
  //     "API_details": "https://api.shadowfax.in/v1/",
  //     "contactInfo": "+91 80000 24680 | support@shadowfax.in",
  //     "serviceArea": "India",
  //     "createdAt": "2025-02-27T09:45:47.071Z",
  //     "updatedAt": "2025-02-27T09:45:47.071Z",
  //     "code": "SAF",
  //     "logoUrl": "http://localhost:5000/logos/shadowfax.svg",
  //     "serviceType": "both",
  //     "slaDays": 2,
  //     "trackingUrl": "https://dale.staging.shadowfax.in/api/v4/clients/orders/awb_number/track/?format=json",
  //     "isActive": true,
  //     "displayName": "SAF - Shadowfax",
  //     "id": "67c0344bf2947d061341a4c1"
  // },

  const setting = useSelector(
    (state) => state.setting?.settings?.courierManagement
  );

  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    if (serviceableCouriers && Array.isArray(serviceableCouriers)) {
      const allCouriers = serviceableCouriers.map((sc) => {
        const settingForCourier = setting?.find((s) => s.courierId === sc._id);
        return {
          id: sc._id,
          name: sc.name,
          icon: sc.logoUrl,
          isActive: settingForCourier?.isEnabled ?? false,
          isServiceable: sc.isActive,
        };
      });

      // Filter to only show serviceable couriers
      const filteredCouriers = allCouriers.filter(
        (courier) => courier.isServiceable
      );
      setCouriers(filteredCouriers);
    }
  }, [setting, serviceableCouriers]);

  const handleToggle = useCallback(
    async (courierId) => {
      setCouriers((prevCouriers) => {
        // Toggle the clicked courier
        const updatedCouriers = prevCouriers.map((courier) =>
          courier.id === courierId
            ? { ...courier, isActive: !courier.isActive }
            : courier
        );

        // Send API request with the latest updated state
        const payload = {
          config: updatedCouriers.map((courier) => ({
            courierId: courier.id,
            isEnabled: courier.isActive, // Use updated isActive state
          })),
        };

        callApi("user/settings/updateCourierSettings", "PUT", payload)
          .then((response) => {
            console.log("API Response:", response);

            if (!response.success) {
              throw new Error(
                response.error.message || "Failed to update courier settings."
              );
            }
            dispatch(addCourierSettings(response.data));
            alert("Courier settings updated successfully!");
          })
          .catch((error) => {
            console.error(
              "Failed to update courier settings:",
              error.message || error
            );
            alert("Failed to update courier settings. Please try again later.");
          });

        return updatedCouriers; // Ensure UI updates correctly
      });
    },
    [callApi] // Only depend on callApi
  );

  const courierList = useMemo(
    () =>
      couriers.map((courier) => (
        <div
          key={courier.id}
          className="flex justify-between items-center w-full bg-background_2 p-4 rounded-xl gap-2"
        >
          <img
            src={courier.icon}
            alt={courier.name}
            className="w-1/2 md:w-fit"
          />
          <ToggleSwitch
            checked={courier.isActive}
            onClick={() => handleToggle(courier.id)}
          />
        </div>
      )),
    [couriers, handleToggle]
  );

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <div className="flex flex-col gap-1 w-full">
          <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
            Courier Management
          </h1>
          <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
            Efficiently manage multiple courier partners by enabling or
            disabling them as needed, ensuring streamlined operations and
            flexibility in delivery options.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
          {courierList}
        </div>
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default CourierMgmt;
